// const baseUrl = "https://pw.systekcn.com/pypw"
const baseUrl = "http://39.103.160.89:8333"
// const baseUrl = "http://192.168.2.180:8333"
export default baseUrl 

/**
 * cors
 * proxy:开发环境
 */


// WEBPACK FOOTER //
// ./src/utils/baseURL.js